import { defaultSkyScrapper, IAdUnit } from "../unit";

export enum ContentPageSkyscraperEnum {
  ContentPageSkyscraperL1 = "Content Page Skyscraper L1",
  ContentPageSkyscraperR1 = "Content Page Skyscraper R1",
  ContentPageSkyscraperL2 = "Content Page Skyscraper L2",
  ContentPageSkyscraperR2 = "Content Page Skyscraper R2",
  ContentPageSkyscraperL3 = "Content Page Skyscraper L3",
  ContentPageSkyscraperR3 = "Content Page Skyscraper R3",
}

export const ContentPageSkyscraperUnits: { [name in ContentPageSkyscraperEnum]: IAdUnit } = {
  [ContentPageSkyscraperEnum.ContentPageSkyscraperL1]: {
    ...defaultSkyScrapper,
    sid: "1081333",
  },
  [ContentPageSkyscraperEnum.ContentPageSkyscraperR1]: {
    ...defaultSkyScrapper,
    sid: "1081334",
  },
  [ContentPageSkyscraperEnum.ContentPageSkyscraperL2]: {
    ...defaultSkyScrapper,
    sid: "1232683",
  },
  [ContentPageSkyscraperEnum.ContentPageSkyscraperR2]: {
    ...defaultSkyScrapper,
    sid: "1232684",
  },
  [ContentPageSkyscraperEnum.ContentPageSkyscraperL3]: {
    ...defaultSkyScrapper,
    sid: "1232685",
  },
  [ContentPageSkyscraperEnum.ContentPageSkyscraperR3]: {
    ...defaultSkyScrapper,
    sid: "1232686",
  },
};
